import {
  useGetStatInfoCommonInfoQuery,
  useComputeAndCacheStatInfosMutation,
  useComputeAndCacheGroupStatInfosMutation,
} from "../../features/api/statInfoApi";
import {
  StatInfoCommonInfoModel,
  StatInfoComputeModel,
  StatInfoGroupComputeModel,
} from "../../entities/statInfo";
import { useStatInfoRoutes } from "./routes";
import { Col, Collapse, message, Row } from "antd";
import { Spin, Tabs, Descriptions } from "antd";
import { DateTimeViewer, EnumViewer } from "../../components";
import { Outlet } from "react-router-dom";
import { StatGroup } from "../../entities/enums";
import { StatInfoComputer } from "./statInfoComputer";
import { StatInfoGroupComputer } from "./StatInfoGroupComputer";

export { useStatInfoRoutes };

const StatInfosIndexPage = () => {
  const { data, isLoading, isFetching } =
    useGetStatInfoCommonInfoQuery(undefined);

  const [computeStatInfos] = useComputeAndCacheStatInfosMutation();
  const [reComputeStatInfos] = useComputeAndCacheGroupStatInfosMutation();

  const compute = async (model: StatInfoComputeModel) => {
    try {
      message.loading({
        content: "در حال محاسبه اطلاعات آماری",
        key: "computeStatInfos",
        duration: 0,
      });

      await computeStatInfos(model).unwrap();

      message.success({
        content: "اطلاعات آماری با موفقیت محاسبه و ذخیره شد",
        key: "computeStatInfos",
        duration: 5,
      });

      return true;
    } catch {
      message.error({
        content: "محاسبه اطلاعات آماری با خطا مواجه شد",
        key: "computeStatInfos",
        duration: 5,
      });

      return false;
    }
  };

  const computeGroup = async (model: StatInfoGroupComputeModel) => {
    try {
      message.loading({
        content: "در حال محاسبه گروهی اطلاعات آماری",
        key: "reComputeStatInfos",
        duration: 0,
      });

      await reComputeStatInfos(model).unwrap();

      message.success({
        content: "اطلاعات آماری با موفقیت محاسبه و ذخیره شد",
        key: "reComputeStatInfos",
        duration: 5,
      });

      return true;
    } catch {
      message.error({
        content: "محاسبه گروهی اطلاعات آماری با خطا مواجه شد",
        key: "reComputeStatInfos",
        duration: 5,
      });

      return false;
    }
  };

  const info: StatInfoCommonInfoModel = {
    groupInfos: data?.groupInfos ?? [],
  };

  return (
    <div>
      <Collapse bordered={true}>
        <Collapse.Panel
          key="1"
          header={
            <span className="text-lg">اطلاعات آماری</span>
          }
        >
          <Spin spinning={isLoading || isFetching}>
            <Tabs defaultActiveKey="1" tabPosition="top">
              <Tabs.TabPane tab="اطلاعات کلی" key="info">
                <Row>
                  {info.groupInfos?.map((x) => (
                    <Col xs={24} lg={12} xxl={8} key={x.group}>
                      <Descriptions
                        size="small"
                        column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
                        title={
                          <span className="text-sm text-gray-500">
                            <EnumViewer type={StatGroup} value={x.group} />
                          </span>
                        }
                      >
                        <Descriptions.Item
                          label="تعداد کل"
                          labelStyle={{ color: "gray" }}
                        >
                          {x.totalRecords}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label="آخرین آمار"
                          labelStyle={{ color: "gray" }}
                        >
                          <DateTimeViewer
                            value={x.lastComputedStatInfo}
                            mode="distance"
                          />
                        </Descriptions.Item>
                      </Descriptions>
                    </Col>
                  ))}
                </Row>
              </Tabs.TabPane>
              <Tabs.TabPane tab="محاسبه" key="compute">
                <StatInfoComputer computeCallback={compute} />
              </Tabs.TabPane>
              <Tabs.TabPane tab="محاسبه گروهی" key="reCompute">
                <StatInfoGroupComputer computeCallback={computeGroup} />
              </Tabs.TabPane>
            </Tabs>
          </Spin>
        </Collapse.Panel>
      </Collapse>
      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  );
};

export default StatInfosIndexPage;
